import { create } from 'zustand'

export const useSidebarStore = create((set, get) => ({
  isOpen: true,
  isMobile: false,
  toggle: () => set({ isOpen: !get().isOpen }),
  setOpen: (isOpen) => set({ isOpen }),
  setMobile: (isMobile) => set({ isMobile }),
}))